"use client";

import { ListCard } from "@/components/shared";
import type { PublisherGame } from "../types";
import { parsePriceFormatted } from "../utils/parsePrice";

interface PublisherGameCardsProps {
  games: PublisherGame[];
  onCardClick: (appid: number) => void;
}

export function PublisherGameCards({
  games,
  onCardClick,
}: PublisherGameCardsProps) {
  return (
    <div className="md:hidden">
      {games.map((game) => (
        <ListCard
          key={game.appid}
          item={game}
          onCardClick={onCardClick}
          renderImage={(game: PublisherGame) => ({
            src: game.capsule_image || game.header_image,
            alt: game.name,
            width: 120,
            height: 45,
          })}
          renderTitle={(game: PublisherGame) => game.name}
          renderPrice={(game: PublisherGame) =>
            parsePriceFormatted(game.price_final_formatted)
          }
          renderPlatforms={() => ({
            supportsWindows: null,
            supportsMac: null,
            supportsLinux: null,
          })}
          renderMetadata={(game: PublisherGame) => (
            <>
              <p className="mb-1">
                <span className="text-[#66c0f4]">ID: {game.appid}</span>
              </p>
              {(game.release_date || game.coming_soon) && (
                <p className="mb-1">
                  Release:{" "}
                  {game.coming_soon ? "Coming Soon" : game.release_date}
                </p>
              )}
              {game.total_reviews && game.total_reviews > 0 && (
                <p className="mb-1">
                  Reviews: {game.total_reviews.toLocaleString("en-US")}
                  {game.review_score_label && (
                    <span className="ml-1 text-[#8f98a0]">
                      ({game.review_score_label})
                    </span>
                  )}
                  {game.percent_positive !== null && (
                    <span className="ml-1 text-[#8f98a0]">
                      {game.percent_positive}% positive
                    </span>
                  )}
                </p>
              )}
              {game.followers != null && (
                <p className="mb-1">
                  Followers:{" "}
                  <span className="text-[#66c0f4]">
                    {game.followers.toLocaleString("en-US")}
                  </span>
                </p>
              )}
            </>
          )}
        />
      ))}
    </div>
  );
}
